<template>
	<div>
		<AppHeader title="지점 대기 신청 내역" is-history />

		<AppContent>
			<ReservationWaitingList />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import AppFooter from '@/components/common/AppFooter';
import ReservationWaitingList from '@/components/ReservationWaiting/ReservationWaitingList';

export default {
	components: {
		AppHeader,
		AppContent,
		AppFooter,
		ReservationWaitingList,
	},
};
</script>
